<template>
  <div class="text-sm">
    <p class="mt-6"><b>2026.02.11</b> - Caverns improvements & bug fixes</p>
    <div class="ml-5 pb-4 text-pink-400">
      <div class="font-bold mt-2">Bug Fixes</div>
      <ul class="ml-4 list-disc">
        <li>Fixed XP potion display showing incorrectly when the potion had expired</li>
        <li>Fixed Caverns mob spawning and tile occupation tracking issues</li>
        <li>Fixed Caverns operations that could incorrectly occur during travel or surfacing</li>
        <li>Fixed missing Caverns run data handling to prevent errors</li>
        <li>Fixed Caverns battle events not processing when the game tab was hidden</li>
      </ul>

      <div class="font-bold mt-2">QoL</div>
      <ul class="ml-4 list-disc">
        <li>
          Improved Caverns battle log by batching "inspired" messages together for better
          readability
        </li>
        <li>Improved Caverns battle log by batching heal events together for better readability</li>
        <li>Added Russian translations for all devlog entries and announcements</li>
      </ul>
    </div>
  </div>
</template>
